import { React, useState } from "react"
import AgreeButton from "../AgreeButton"
import TnCModal from "../TnCModal"
import PrivacyModal from "../PrivacyModal"
import noticeIcon from "../../assets/notice.png"

function CustomFooter({ id, rrn, opt, redirect, tncText, privacyText }) {
  // modal state
  const [openModal, setOpenModal] = useState("")

  const openTnCModal = () => {
    setOpenModal("tnc")
  }

  const openPrivModal = () => {
    setOpenModal("privacy")
  }

  const closeModal = () => {
    setOpenModal("")
  }

  return (
    <>
      <div className="footer">
        <p className="footer-text">
          {" "}
          <img src={noticeIcon} className="footer-notice" alt="notice" />
          By proceeding, you agree to the above in line with our{" "}
          <button type="button" className="link-button" onClick={openTnCModal}>
            <b> Terms & Conditions </b>
          </button>{" "}
          and{" "}
          <button type="button" className="link-button" onClick={openPrivModal}>
            <b>Privacy Policy</b>
          </button>
          .
        </p>

        <AgreeButton id={id} rrn={rrn} opt={opt} redirect={redirect} />
      </div>

      <div className="modals">
        <TnCModal
          visible={openModal === "tnc"}
          closeModal={closeModal}
          textFile={tncText}
        />
        <PrivacyModal
          visible={openModal === "privacy"}
          closeModal={closeModal}
          textFile={privacyText}
        />
      </div>
    </>
  )
}

export default CustomFooter
